import {makeStyles, MenuItem, Theme} from "@material-ui/core";
import {FilterList} from "@material-ui/icons";
import React from "react";

import {FilterMenu} from "@ofqual/portal-components/components/ResponseFilter";

import {useLookup, useSearch, useUrl} from "@ofqual/portal-core/core/hooks";
import {Select} from "@ofqual/portal-components/components/Select";
import {ensureParamIsArray} from "@ofqual/portal-core/core/utils/urlHelper";
import {contactTypeService} from "../../services";

const useStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            "& fieldset": {
                borderColor: theme.palette.primary.main,
            },
        },
        menuItem: {
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
    };
});

export const DashboardFilterControls: React.FC = () => {
    const classes = useStyles();

    const {
        navigateToNextSearch,
        searchParamsFiltersOnly,
    } = useSearch(useUrl());

    const [sourceLookups] = useLookup(
        contactTypeService
    );

    return (
      <>
        <FilterMenu
          Icon={FilterList}
          title="Filter"
          dataTest="filter"
          search={{ searchParamsFiltersOnly, navigateToNextSearch }}
        >
          {(workingParams, dirtyParams, addParam, updateMultipleParams) => (
            <form>
              <MenuItem className={classes.menuItem}>
                <Select
                  className={
                    dirtyParams.includes("source") ? classes.root : undefined
                  }
                  label="Source"
                  data-test="source-filter"
                  selectVariant="multiple"
                  value={ensureParamIsArray(workingParams.source)}
                  onChange={(e: any) => addParam("source", e.target.value)}
                >
                  {sourceLookups.map((x) => ({
                    ...x,
                    id: x.id.toString(),
                  }))}
                </Select>
              </MenuItem>
            </form>
          )}
        </FilterMenu>
      </>
    );
};
